import React, { useState } from 'react';
import { Modal } from '../../admin/Modal';
import { AlertTriangle } from 'lucide-react';

interface ConfirmSelfManagedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  clientName: string;
  assignedCoaches: Array<{ coach_id: string; name: string }>;
}

export const ConfirmSelfManagedModal: React.FC<ConfirmSelfManagedModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  clientName,
  assignedCoaches
}) => {
  const [confirmText, setConfirmText] = useState('');
  const hasCoaches = assignedCoaches.length > 0;
  const isConfirmed = confirmText.toUpperCase() === 'CONFIRM';

  const handleConfirm = () => {
    if (!hasCoaches || isConfirmed) {
      onConfirm();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Switch to Self-Managed Mode?"
      variant={hasCoaches ? 'danger' : 'warning'}
      size="small"
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className={hasCoaches ? "btn btn-danger" : "btn btn-primary"}
            onClick={handleConfirm}
            disabled={hasCoaches && !isConfirmed}
          >
            Confirm
          </button>
        </>
      }
    >
      <div style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
          <AlertTriangle size={20} color={hasCoaches ? 'var(--danger)' : 'var(--warning)'} />
          <span style={{ fontWeight: '600', color: 'var(--text-primary)' }}>
            {hasCoaches ? 'Warning: This will remove coach access' : `Give ${clientName} full control`}
          </span>
        </div>

        <div style={{ marginLeft: '28px', color: 'var(--text-secondary)', fontSize: '14px' }}>
          <p style={{ margin: '8px 0' }}>This will:</p>
          <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
            <li>Give the client full control of their goals</li>
            {hasCoaches && (
              <>
                <li style={{ color: 'var(--danger)', fontWeight: '600' }}>
                  Remove coach assignment{assignedCoaches.length > 1 ? 's' : ''}: {assignedCoaches.map(c => c.name).join(', ')}
                </li>
                <li style={{ color: 'var(--danger)', fontWeight: '600' }}>
                  Coach will lose access to manage this client's goals
                </li>
              </>
            )}
          </ul>
        </div>
      </div>

      {hasCoaches && (
        <div style={{ padding: '12px', backgroundColor: 'var(--bg-secondary)', borderRadius: '8px', border: '2px solid var(--danger)' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: 'var(--text-primary)' }}>
            Type "confirm" to proceed:
          </label>
          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="confirm"
            style={{
              width: '100%',
              padding: '8px 12px',
              fontSize: '14px',
              border: '1px solid var(--border)',
              borderRadius: '6px',
              backgroundColor: 'var(--bg-primary)',
              color: 'var(--text-primary)'
            }}
          />
        </div>
      )}
    </Modal>
  );
};
